import { render } from "./PatientList.vue?vue&type=template&id=27dfb15e&scoped=true"
import script from "./PatientList.vue?vue&type=script&lang=js"
export * from "./PatientList.vue?vue&type=script&lang=js"

import "./PatientList.vue?vue&type=style&index=0&id=27dfb15e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27dfb15e"]])

export default __exports__